import { FEATURE_FLAGS } from "constants/FeatureFlags";
import { useMemo } from "react";
import {
  DOCUMENT_GROUP_TAG_TYPES,
  type DocumentGroupTagType,
} from "services/document-group-tag-api";
import { useSelector } from "utils/redux";

export const useEnabledDocumentGroupTagTypes = (): DocumentGroupTagType[] => {
  const featureFlags = useSelector(
    (state) => state.shared.constants?.FEATURE_FLAGS,
  );
  const isRatedAgeEnabled = Boolean(
    featureFlags?.[FEATURE_FLAGS.METADOC_RATED_AGE_REQUEST_ENABLED],
  );
  const isFroiAndCmsSubmissionEnabled = Boolean(
    featureFlags?.[FEATURE_FLAGS.METADOC_FROI_AND_CMS_SUBMISSION_TAGS_ENABLED],
  );

  return useMemo(
    () => [
      ...(isRatedAgeEnabled
        ? [DOCUMENT_GROUP_TAG_TYPES.RECORDS_FOR_RATED_AGE]
        : []),
      ...(isFroiAndCmsSubmissionEnabled
        ? [
            DOCUMENT_GROUP_TAG_TYPES.CMS_SUBMISSION,
            DOCUMENT_GROUP_TAG_TYPES.FROI,
          ]
        : []),
    ],
    [isRatedAgeEnabled, isFroiAndCmsSubmissionEnabled],
  );
};
